"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@emotion/core");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  return (0, _core.jsx)("path", {
    d: "M415.7 41.2H82.3c-23 0-41.7 18.6-41.7 41.7v333.4c0 23 18.6 41.7 41.7 41.7h333.4c23 0 41.7-18.6 41.7-41.7V82.8c-.1-23-18.7-41.6-41.7-41.6zM177.3 379h-49.2V198.6h49.2V379zm-24.6-201.1c-15.8 0-28.7-13-28.7-28.9s12.9-28.9 28.7-28.9 28.7 13 28.7 28.9-12.9 28.9-28.7 28.9zM374 379h-49.2v-91.9c0-55.2-65.6-51-65.6 0V379H210V198.6h49.2v28.9C282.1 185.1 374 182 374 268.1V379z"
  });
};

exports.default = _default;